/**
 * One kind's bucket in a context attribute values response
 * (GET /api/v2/projects/{p}/environments/{e}/context-attributes/{attr}):
 * the response groups values per context kind, with each value in `name`.
 * The wire contract allows non-string values (numbers occur in real data).
 */
export type ContextAttributeValuesByKind = {
  kind?: string;
  values?: ReadonlyArray<{
    name: unknown;
    weight: number;
  }>;
};

/**
 * Flattens a context attribute values response into select options for the
 * requested context kind. This is the only place that knows the response's
 * per-kind bucket shape; consume the endpoint through it rather than mapping
 * `items` by hand. Generic over the value type so callers with a narrower
 * wire type (e.g. string-only names) keep their typing; labels are always
 * strings because completion and select components require them.
 */
export const makeSelectOptionsForContextAttributeValues = <T>(
  contextAttributesValuesList: ReadonlyArray<{ kind?: string; values?: ReadonlyArray<{ name: T }> }> | undefined,
  contextKind: string,
): Array<{ label: string; value: T }> => {
  const options: Array<{ label: string; value: T }> = [];
  const attributeValuesForContextKind = contextAttributesValuesList?.find((c) => c.kind === contextKind);
  attributeValuesForContextKind?.values?.forEach((v) => {
    options.push({
      label: String(v.name ?? ''),
      value: v.name,
    });
  });

  return options;
};
